export function getNameFile(name){

    return {
        type: 'GET_NAME_FILE',
        payload: {name}
    }
}
